var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "layout" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-xs-12 col-md-6" }, [
        _c("div", { staticClass: "form-field" }, [
          _c(
            "div",
            { staticClass: "file-upload-field" },
            [
              _c("label", [_vm._v("Foto")]),
              _vm._v(" "),
              _c("file-upload", {
                ref: "fileUpload",
                attrs: { defaultImage: _vm.srcImagen }
              })
            ],
            1
          ),
          _vm._v(" "),
          _vm.errores.imagen
            ? _c(
                "span",
                {
                  staticClass: "helper-text text-danger",
                  attrs: { slot: "helper" },
                  slot: "helper"
                },
                [_c("strong", [_vm._v(_vm._s(_vm.errores.imagen[0]))])]
              )
            : _vm._e()
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-6" }, [
        _c(
          "div",
          { staticClass: "form-field" },
          [
            _c(
              "input-field",
              {
                attrs: { id: "nombre", placeholder: "Nombres" },
                model: {
                  value: _vm.form.nombre,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "nombre", $$v)
                  },
                  expression: "form.nombre"
                }
              },
              [
                _c("span", [_vm._v("Nombre")]),
                _vm._v(" "),
                _vm.errores.nombre
                  ? _c(
                      "span",
                      {
                        staticClass: "helper-text text-danger",
                        attrs: { slot: "helper" },
                        slot: "helper"
                      },
                      [_c("strong", [_vm._v(_vm._s(_vm.errores.nombre[0]))])]
                    )
                  : _vm._e()
              ]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-6" }, [
        _c(
          "div",
          { staticClass: "form-field" },
          [
            _c(
              "input-field",
              {
                attrs: { id: "apellido", placeholder: "Apellidos" },
                model: {
                  value: _vm.form.apellido,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "apellido", $$v)
                  },
                  expression: "form.apellido"
                }
              },
              [
                _c("span", [_vm._v("Apellidos")]),
                _vm._v(" "),
                _vm.errores.apellido
                  ? _c(
                      "span",
                      {
                        staticClass: "helper-text text-danger",
                        attrs: { slot: "helper" },
                        slot: "helper"
                      },
                      [_c("strong", [_vm._v(_vm._s(_vm.errores.apellido[0]))])]
                    )
                  : _vm._e()
              ]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-6" }, [
        _c(
          "div",
          { staticClass: "form-field" },
          [
            _c(
              "input-field",
              {
                attrs: {
                  type: "password",
                  id: "clave_acceso",
                  placeholder: "Clave de acceso"
                },
                model: {
                  value: _vm.form.clave_acceso,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "clave_acceso", $$v)
                  },
                  expression: "form.clave_acceso"
                }
              },
              [
                _c("span", [_vm._v("Contraseña")]),
                _vm._v(" "),
                _vm.errores.clave_acceso
                  ? _c(
                      "span",
                      {
                        staticClass: "helper-text text-danger",
                        attrs: { slot: "helper" },
                        slot: "helper"
                      },
                      [
                        _c("strong", [
                          _vm._v(_vm._s(_vm.errores.clave_acceso[0]))
                        ])
                      ]
                    )
                  : _vm._e()
              ]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-6" }, [
        _c(
          "div",
          { staticClass: "form-field" },
          [
            _c(
              "input-field",
              {
                attrs: {
                  type: "password",
                  id: "clave_acceso_confirmation",
                  placeholder: "Confirmar clave..."
                },
                model: {
                  value: _vm.form.clave_acceso_confirmation,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "clave_acceso_confirmation", $$v)
                  },
                  expression: "form.clave_acceso_confirmation"
                }
              },
              [
                _c("span", [_vm._v("Confirmación de contraseña")]),
                _vm._v(" "),
                _vm.errores.clave_acceso_confirmation
                  ? _c(
                      "span",
                      {
                        staticClass: "helper-text text-danger",
                        attrs: { slot: "helper" },
                        slot: "helper"
                      },
                      [
                        _c("strong", [
                          _vm._v(
                            _vm._s(_vm.errores.clave_acceso_confirmation[0])
                          )
                        ])
                      ]
                    )
                  : _vm._e()
              ]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-6" }, [
        _c("div", { staticClass: "form-field" }, [
          _c(
            "div",
            { staticClass: "datepicker-field" },
            [
              _c("date-picker", {
                attrs: { type: "date", id: "fecha_nacimiento" },
                model: {
                  value: _vm.form.fecha_nacimiento,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "fecha_nacimiento", $$v)
                  },
                  expression: "form.fecha_nacimiento"
                }
              }),
              _vm._v(" "),
              _c("label", [_vm._v("Fecha de nacimiento")]),
              _vm._v(" "),
              _vm.errores.fecha_nacimiento
                ? _c(
                    "span",
                    {
                      staticClass: "helper-text text-danger",
                      attrs: { slot: "helper" },
                      slot: "helper"
                    },
                    [
                      _c("strong", [
                        _vm._v(_vm._s(_vm.errores.fecha_nacimiento[0]))
                      ])
                    ]
                  )
                : _vm._e()
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-6" }, [
        _c(
          "div",
          { staticClass: "form-field" },
          [
            _c(
              "input-field",
              {
                attrs: {
                  readonly: "",
                  id: "edad",
                  placeholder: "Edad",
                  value: _vm.edad
                }
              },
              [_c("span", [_vm._v("Edad")])]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-6" }, [
        _c(
          "div",
          { staticClass: "form-field" },
          [
            _c(
              "input-field",
              {
                directives: [
                  {
                    name: "mask",
                    rawName: "v-mask",
                    value: "#############",
                    expression: "'#############'"
                  }
                ],
                attrs: {
                  id: "cedula",
                  placeholder: "Número de identificación"
                },
                model: {
                  value: _vm.form.identificacion,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "identificacion", $$v)
                  },
                  expression: "form.identificacion"
                }
              },
              [
                _c("span", [_vm._v("Cédula/Pasaporte")]),
                _vm._v(" "),
                _vm.errores.identificacion
                  ? _c(
                      "span",
                      {
                        staticClass: "helper-text text-danger",
                        attrs: { slot: "helper" },
                        slot: "helper"
                      },
                      [
                        _c("strong", [
                          _vm._v(_vm._s(_vm.errores.identificacion[0]))
                        ])
                      ]
                    )
                  : _vm._e()
              ]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-6" }, [
        _c(
          "div",
          { staticClass: "form-field" },
          [
            _c(
              "input-field",
              {
                attrs: {
                  id: "direccion",
                  placeholder: "Escriba una dirección..."
                },
                model: {
                  value: _vm.form.direccion,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "direccion", $$v)
                  },
                  expression: "form.direccion"
                }
              },
              [
                _c("span", [_vm._v("Dirección")]),
                _vm._v(" "),
                _vm.errores.direccion
                  ? _c(
                      "span",
                      {
                        staticClass: "helper-text text-danger",
                        attrs: { slot: "helper" },
                        slot: "helper"
                      },
                      [_c("strong", [_vm._v(_vm._s(_vm.errores.direccion[0]))])]
                    )
                  : _vm._e()
              ]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-6" }, [
        _c(
          "div",
          { staticClass: "form-field" },
          [
            _c(
              "input-field",
              {
                attrs: {
                  id: "telefono",
                  placeholder: "Escriba un teléfono..."
                },
                model: {
                  value: _vm.form.telefono,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "telefono", $$v)
                  },
                  expression: "form.telefono"
                }
              },
              [
                _c("span", [_vm._v("Teléfono")]),
                _vm._v(" "),
                _vm.errores.telefono
                  ? _c(
                      "span",
                      {
                        staticClass: "helper-text text-danger",
                        attrs: { slot: "helper" },
                        slot: "helper"
                      },
                      [_c("strong", [_vm._v(_vm._s(_vm.errores.telefono[0]))])]
                    )
                  : _vm._e()
              ]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-6" }, [
        _c(
          "div",
          { staticClass: "form-field" },
          [
            _c(
              "input-field",
              {
                attrs: { id: "celular", placeholder: "Escriba un celular..." },
                model: {
                  value: _vm.form.celular,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "celular", $$v)
                  },
                  expression: "form.celular"
                }
              },
              [
                _c("span", [_vm._v("Celular")]),
                _vm._v(" "),
                _vm.errores.celular
                  ? _c(
                      "span",
                      {
                        staticClass: "helper-text text-danger",
                        attrs: { slot: "helper" },
                        slot: "helper"
                      },
                      [_c("strong", [_vm._v(_vm._s(_vm.errores.celular[0]))])]
                    )
                  : _vm._e()
              ]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-6" }, [
        _c(
          "div",
          { staticClass: "form-field" },
          [
            _c(
              "input-field",
              {
                attrs: {
                  id: "email",
                  placeholder: "Escriba una dirección de correo electrónico..."
                },
                model: {
                  value: _vm.form.email,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "email", $$v)
                  },
                  expression: "form.email"
                }
              },
              [
                _c("span", [_vm._v("Correo electrónico")]),
                _vm._v(" "),
                _vm.errores.email
                  ? _c(
                      "span",
                      {
                        staticClass: "helper-text text-danger",
                        attrs: { slot: "helper" },
                        slot: "helper"
                      },
                      [_c("strong", [_vm._v(_vm._s(_vm.errores.email[0]))])]
                    )
                  : _vm._e()
              ]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-6" }, [
        _c("label", { attrs: { for: "masculino" } }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.form.sexo,
                expression: "form.sexo"
              }
            ],
            attrs: { type: "radio", name: "sexo", id: "masculino", value: "M" },
            domProps: { checked: _vm._q(_vm.form.sexo, "M") },
            on: {
              change: function($event) {
                return _vm.$set(_vm.form, "sexo", "M")
              }
            }
          }),
          _vm._v(" "),
          _c("span", [_vm._v("Masculino")])
        ]),
        _vm._v(" "),
        _c("label", { attrs: { for: "femenino" } }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.form.sexo,
                expression: "form.sexo"
              }
            ],
            attrs: { type: "radio", name: "sexo", id: "femenino", value: "F" },
            domProps: { checked: _vm._q(_vm.form.sexo, "F") },
            on: {
              change: function($event) {
                return _vm.$set(_vm.form, "sexo", "F")
              }
            }
          }),
          _vm._v(" "),
          _c("span", [_vm._v("Femenino")])
        ])
      ]),
      _vm._v(" "),
      _vm._m(1),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-4" }, [
        _c("label", { attrs: { for: "hipertension_arterial" } }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.form.hipertension_arterial,
                expression: "form.hipertension_arterial"
              }
            ],
            attrs: {
              type: "checkbox",
              name: "hipertension_arterial",
              id: "hipertension_arterial"
            },
            domProps: {
              checked: Array.isArray(_vm.form.hipertension_arterial)
                ? _vm._i(_vm.form.hipertension_arterial, null) > -1
                : _vm.form.hipertension_arterial
            },
            on: {
              change: function($event) {
                var $$a = _vm.form.hipertension_arterial,
                  $$el = $event.target,
                  $$c = $$el.checked ? true : false
                if (Array.isArray($$a)) {
                  var $$v = null,
                    $$i = _vm._i($$a, $$v)
                  if ($$el.checked) {
                    $$i < 0 &&
                      _vm.$set(
                        _vm.form,
                        "hipertension_arterial",
                        $$a.concat([$$v])
                      )
                  } else {
                    $$i > -1 &&
                      _vm.$set(
                        _vm.form,
                        "hipertension_arterial",
                        $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                      )
                  }
                } else {
                  _vm.$set(_vm.form, "hipertension_arterial", $$c)
                }
              }
            }
          }),
          _c("span", [_vm._v("Hipertensión arterial")])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-4" }, [
        _c("label", { attrs: { for: "diabetes_mellitus" } }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.form.diabetes_mellitus,
                expression: "form.diabetes_mellitus"
              }
            ],
            attrs: {
              type: "checkbox",
              name: "diabetes_mellitus",
              id: "diabetes_mellitus"
            },
            domProps: {
              checked: Array.isArray(_vm.form.diabetes_mellitus)
                ? _vm._i(_vm.form.diabetes_mellitus, null) > -1
                : _vm.form.diabetes_mellitus
            },
            on: {
              change: function($event) {
                var $$a = _vm.form.diabetes_mellitus,
                  $$el = $event.target,
                  $$c = $$el.checked ? true : false
                if (Array.isArray($$a)) {
                  var $$v = null,
                    $$i = _vm._i($$a, $$v)
                  if ($$el.checked) {
                    $$i < 0 &&
                      _vm.$set(_vm.form, "diabetes_mellitus", $$a.concat([$$v]))
                  } else {
                    $$i > -1 &&
                      _vm.$set(
                        _vm.form,
                        "diabetes_mellitus",
                        $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                      )
                  }
                } else {
                  _vm.$set(_vm.form, "diabetes_mellitus", $$c)
                }
              }
            }
          }),
          _c("span", [_vm._v("Diabetes mellitus")])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-4" }, [
        _c("label", { attrs: { for: "cirrosis_hepatica" } }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.form.cirrosis_hepatica,
                expression: "form.cirrosis_hepatica"
              }
            ],
            attrs: {
              type: "checkbox",
              name: "cirrosis_hepatica",
              id: "cirrosis_hepatica"
            },
            domProps: {
              checked: Array.isArray(_vm.form.cirrosis_hepatica)
                ? _vm._i(_vm.form.cirrosis_hepatica, null) > -1
                : _vm.form.cirrosis_hepatica
            },
            on: {
              change: function($event) {
                var $$a = _vm.form.cirrosis_hepatica,
                  $$el = $event.target,
                  $$c = $$el.checked ? true : false
                if (Array.isArray($$a)) {
                  var $$v = null,
                    $$i = _vm._i($$a, $$v)
                  if ($$el.checked) {
                    $$i < 0 &&
                      _vm.$set(_vm.form, "cirrosis_hepatica", $$a.concat([$$v]))
                  } else {
                    $$i > -1 &&
                      _vm.$set(
                        _vm.form,
                        "cirrosis_hepatica",
                        $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                      )
                  }
                } else {
                  _vm.$set(_vm.form, "cirrosis_hepatica", $$c)
                }
              }
            }
          }),
          _c("span", [_vm._v("Cirrosis hepática")])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-4" }, [
        _c("label", { attrs: { for: "insuficiencia_renal" } }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.form.insuficiencia_renal,
                expression: "form.insuficiencia_renal"
              }
            ],
            attrs: {
              type: "checkbox",
              name: "insuficiencia_renal",
              id: "insuficiencia_renal"
            },
            domProps: {
              checked: Array.isArray(_vm.form.insuficiencia_renal)
                ? _vm._i(_vm.form.insuficiencia_renal, null) > -1
                : _vm.form.insuficiencia_renal
            },
            on: {
              change: function($event) {
                var $$a = _vm.form.insuficiencia_renal,
                  $$el = $event.target,
                  $$c = $$el.checked ? true : false
                if (Array.isArray($$a)) {
                  var $$v = null,
                    $$i = _vm._i($$a, $$v)
                  if ($$el.checked) {
                    $$i < 0 &&
                      _vm.$set(
                        _vm.form,
                        "insuficiencia_renal",
                        $$a.concat([$$v])
                      )
                  } else {
                    $$i > -1 &&
                      _vm.$set(
                        _vm.form,
                        "insuficiencia_renal",
                        $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                      )
                  }
                } else {
                  _vm.$set(_vm.form, "insuficiencia_renal", $$c)
                }
              }
            }
          }),
          _c("span", [_vm._v("Insuficiencia renal")])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-4" }, [
        _c("label", { attrs: { for: "hipotiroidismo" } }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.form.hipotiroidismo,
                expression: "form.hipotiroidismo"
              }
            ],
            attrs: {
              type: "checkbox",
              name: "hipotiroidismo",
              id: "hipotiroidismo"
            },
            domProps: {
              checked: Array.isArray(_vm.form.hipotiroidismo)
                ? _vm._i(_vm.form.hipotiroidismo, null) > -1
                : _vm.form.hipotiroidismo
            },
            on: {
              change: function($event) {
                var $$a = _vm.form.hipotiroidismo,
                  $$el = $event.target,
                  $$c = $$el.checked ? true : false
                if (Array.isArray($$a)) {
                  var $$v = null,
                    $$i = _vm._i($$a, $$v)
                  if ($$el.checked) {
                    $$i < 0 &&
                      _vm.$set(_vm.form, "hipotiroidismo", $$a.concat([$$v]))
                  } else {
                    $$i > -1 &&
                      _vm.$set(
                        _vm.form,
                        "hipotiroidismo",
                        $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                      )
                  }
                } else {
                  _vm.$set(_vm.form, "hipotiroidismo", $$c)
                }
              }
            }
          }),
          _c("span", [_vm._v("Hipotiroidismo")])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-4" }, [
        _c("label", { attrs: { for: "insuficiencia_cardiaca" } }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.form.insuficiencia_cardiaca,
                expression: "form.insuficiencia_cardiaca"
              }
            ],
            attrs: {
              type: "checkbox",
              name: "insuficiencia_cardiaca",
              id: "insuficiencia_cardiaca"
            },
            domProps: {
              checked: Array.isArray(_vm.form.insuficiencia_cardiaca)
                ? _vm._i(_vm.form.insuficiencia_cardiaca, null) > -1
                : _vm.form.insuficiencia_cardiaca
            },
            on: {
              change: function($event) {
                var $$a = _vm.form.insuficiencia_cardiaca,
                  $$el = $event.target,
                  $$c = $$el.checked ? true : false
                if (Array.isArray($$a)) {
                  var $$v = null,
                    $$i = _vm._i($$a, $$v)
                  if ($$el.checked) {
                    $$i < 0 &&
                      _vm.$set(
                        _vm.form,
                        "insuficiencia_cardiaca",
                        $$a.concat([$$v])
                      )
                  } else {
                    $$i > -1 &&
                      _vm.$set(
                        _vm.form,
                        "insuficiencia_cardiaca",
                        $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                      )
                  }
                } else {
                  _vm.$set(_vm.form, "insuficiencia_cardiaca", $$c)
                }
              }
            }
          }),
          _c("span", [_vm._v("Insuficiencia cardíaca")])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-4" }, [
        _c("label", { attrs: { for: "otras" } }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.form.otras,
                expression: "form.otras"
              }
            ],
            attrs: { type: "checkbox", name: "otras", id: "otras" },
            domProps: {
              checked: Array.isArray(_vm.form.otras)
                ? _vm._i(_vm.form.otras, null) > -1
                : _vm.form.otras
            },
            on: {
              change: function($event) {
                var $$a = _vm.form.otras,
                  $$el = $event.target,
                  $$c = $$el.checked ? true : false
                if (Array.isArray($$a)) {
                  var $$v = null,
                    $$i = _vm._i($$a, $$v)
                  if ($$el.checked) {
                    $$i < 0 && _vm.$set(_vm.form, "otras", $$a.concat([$$v]))
                  } else {
                    $$i > -1 &&
                      _vm.$set(
                        _vm.form,
                        "otras",
                        $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                      )
                  }
                } else {
                  _vm.$set(_vm.form, "otras", $$c)
                }
              }
            }
          }),
          _c("span", [_vm._v("Otras")])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12" }),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-6" }, [
        _c(
          "div",
          { staticClass: "form-field" },
          [
            _c(
              "input-field",
              {
                attrs: {
                  id: "email",
                  placeholder: "Escriba el tratamiento..."
                },
                model: {
                  value: _vm.form.tratamiento,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "tratamiento", $$v)
                  },
                  expression: "form.tratamiento"
                }
              },
              [
                _c("span", [_vm._v("Tratamientos")]),
                _vm._v(" "),
                _vm.errores.tratamiento
                  ? _c(
                      "span",
                      {
                        staticClass: "helper-text text-danger",
                        attrs: { slot: "helper" },
                        slot: "helper"
                      },
                      [
                        _c("strong", [
                          _vm._v(_vm._s(_vm.errores.tratamiento[0]))
                        ])
                      ]
                    )
                  : _vm._e()
              ]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-6" }, [
        _c(
          "div",
          { staticClass: "form-field" },
          [
            _c(
              "input-field",
              {
                attrs: { id: "email", placeholder: "Escriba sus alergias..." },
                model: {
                  value: _vm.form.alergias,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "alergias", $$v)
                  },
                  expression: "form.alergias"
                }
              },
              [
                _c("span", [_vm._v("Alergias")]),
                _vm._v(" "),
                _vm.errores.alergias
                  ? _c(
                      "span",
                      {
                        staticClass: "helper-text text-danger",
                        attrs: { slot: "helper" },
                        slot: "helper"
                      },
                      [_c("strong", [_vm._v(_vm._s(_vm.errores.alergias[0]))])]
                    )
                  : _vm._e()
              ]
            )
          ],
          1
        )
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "modal-buttons" }, [
      _c(
        "button",
        {
          staticClass: "btn-success",
          attrs: { type: "button" },
          on: { click: _vm.guardar }
        },
        [
          _c("i", { staticClass: "fa fa-save" }),
          _vm._v(" "),
          _c("span", [_vm._v("Guardar")])
        ]
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "btn-danger btn--text",
          attrs: { type: "button" },
          on: {
            click: function($event) {
              return _vm.$emit("cancelar")
            }
          }
        },
        [
          _c("i", { staticClass: "fa fa-ban" }),
          _vm._v(" "),
          _c("span", [_vm._v("Cancelar")])
        ]
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "layout__header" }, [
      _c("div", { staticClass: "layout__title" }, [
        _c("h3", [_vm._v("Paciente")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-xs-12" }, [
      _c("h5", [_vm._v("Datos de filiación")])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-83574456", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-83574456","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/pacientes/Paciente.vue
// module id = 600
// module chunks = 0